import React, { useEffect, useRef } from "react";

import PropTypes from "prop-types";
import { Tab } from "semantic-ui-react";

import RulesTab from "../RulesTab";
import SettingsTab from "../SettingsTab";
import styles from "./styles.css";

const ExtraSettingsTabs = ({
	completeFormModel,
	CustomSettingsComponent,
	parentQuestionConfig,
	onChangeConfig
}) => {
	const tabsContainerRef = useRef();

	const panes = [
		{
			id: "settings-tab",
			menuItem: "Settings",
			render: () => (
				<Tab.Pane role="tabpanel" id="settings-tab">
					<SettingsTab
						CustomSettingsComponent={CustomSettingsComponent}
						parentQuestionConfig={parentQuestionConfig}
						onChangeConfig={onChangeConfig}
					/>
				</Tab.Pane>
			)
		},
		{
			id: "display-rules-tab",
			menuItem: "Display Rules",
			render: () => (
				<Tab.Pane role="tabpanel" id="display-rules-tab">
					<RulesTab
						ruleType="visible"
						parentQuestionConfig={parentQuestionConfig}
						completeFormModel={completeFormModel}
						onChange={onChangeConfig}
					/>
				</Tab.Pane>
			)
		},
		{
			id: "ignore-rules-tab",
			menuItem: "Ignore Rules",
			render: () => (
				<Tab.Pane role="tabpanel" id="ignore-rules-tab">
					<RulesTab
						ruleType="ignore"
						parentQuestionConfig={parentQuestionConfig}
						completeFormModel={completeFormModel}
						onChange={onChangeConfig}
					/>
				</Tab.Pane>
			)
		},
	];

	useEffect(() => {
		if (tabsContainerRef?.current) {
			const tabsList = tabsContainerRef?.current.querySelectorAll("div[role='tablist'] a");

			const changeAriaSelectedAttribute = (tabsList, event) => {
				tabsList.forEach(tab => {
					tab.setAttribute("aria-selected", "false");
				});

				event.target.setAttribute("aria-selected", "true");
			};

			tabsList.forEach((tab, tabIndex) => {
				tab.setAttribute("tabindex", "0");
				tab.setAttribute("role", "tab");
				tab.setAttribute("aria-selected", "false");

				panes.forEach(({ id }, paneIndex) => {
					if (tabIndex === paneIndex) {
						tab.setAttribute("aria-controls", id);
					}
				});

				if (tab.classList.contains("active")) {
					tab.setAttribute("aria-selected", "true");
				}

				tab.addEventListener("click", event => {
					changeAriaSelectedAttribute(tabsList, event);
				});

				tab.addEventListener("keydown", event => {
					if (event.key === "Enter") {
						event.target.click();
					}
				});
			});
		}
	}, []);

	return (
		<div className={`ui input ${styles.tabsContainer}`} ref={tabsContainerRef}>
			<Tab panes={panes} role="tablist" aria-label="More question settings" />
		</div>
	);
};

ExtraSettingsTabs.defaultProps = {
	CustomSettingsComponent: null,
};

ExtraSettingsTabs.propTypes = {
	completeFormModel: PropTypes.any.isRequired,
	CustomSettingsComponent: PropTypes.elementType,
	parentQuestionConfig: PropTypes.any.isRequired,
	onChangeConfig: PropTypes.func.isRequired,
};

export default ExtraSettingsTabs;
